import { CustomHandle } from '@/adapter/blockAdapter';
import { createContext } from 'react';

type SelectedContextType = {
  selectedEdge: CustomHandle | undefined;
  setSelectedEdge: (handle: CustomHandle) => void;
};

export const SelectedContext = createContext<SelectedContextType>({
  selectedEdge: undefined,
  setSelectedEdge: () => {}
});
